import React, { useContext, useState, useEffect } from "react";
import { Translate } from "react-i18nify";
import { kioskstyles } from "./../../../../kioskstyles";
import "./../../../../font.css";
import { IdleTimerProvider, useIdleTimerContext } from "react-idle-timer";

// Using a functional component, you must wrap it in React.forwardRef, and then forward the ref to
// the node you want to be the root of the print (usually the outer most node in the ComponentToPrint)
// https://reactjs.org/docs/refs-and-the-dom.html#refs-and-function-components
function IdleTimerDisplay(props) {
  const idleTimer = useIdleTimerContext();
  const [idletimeleft, setIdletimeleft] = useState(30);

  useEffect(() => {
    const interval = setInterval(
      () => setIdletimeleft(Math.floor(idleTimer.getRemainingTime() / 1000)),
      1000
    );

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        position: "absolute",
        bottom: "1vh",
        right: "1vw",
        color: "black",
        display: "flex"
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "parent",
          fontSize: "clamp(12px, 2.5vh, 100px)"
        }}
      >
        {/* Idle: */}
      </div>
      <div
        id="idleTimerCircle"
        class="fontSecondaryText"
        style={{
          marginLeft: "5px",
          width: "clamp(18px, 5vh, 100px)",
          height: "clamp(18px, 5vh, 100px)",
          fontSize: "clamp(12px, 2.5vh, 100px)",
          borderRadius: "50px",
          backgroundColor: "white"
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%"
          }}
        >
          <span style={{ color: "black" }}>{idletimeleft}</span>
        </div>
      </div>
    </div>
  );
}

export default IdleTimerDisplay;
